import {useEffect} from 'react'
import {useParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostRemaningPlayerAddOn = () => {
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const clickEvent = (action) => {
		fetchRequest(
			'POST',
			action === 'increase'
				? `/admin/event/${idx}/participant/addon/increase`
				: `/admin/event/${idx}/participant/addon/decrease`
		)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				window.location.reload()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'event_idx')
					setAlert('대회 idx 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'participant_idx')
					setAlert('참가자 idx 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 데이터가 존재하지 않습니다.')
				else if (fetchResult?.data?.error_code === 2)
					setAlert('참가자 데이터가 존재하지 않습니다.')
				break
			case 409:
				if (fetchResult?.data?.error_code === 1)
					setAlert('이미 에드온을 지급한 참가자 입니다.')
				break
		}
	}, [fetchResult])

	return [clickEvent]
}

export default usePostRemaningPlayerAddOn
